// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2fcg2","infoBtn":"quickbooks_infoBtn__1HWyj","formBox":"quickbooks_formBox__j3-94","formFooter":"quickbooks_formFooter__1g4k1"};